import type { Props4 } from "../Types";
import { sanitizeImageUrl } from "../imageUrl";

// Top Tips Card Layout
const CardLayout4 = ({consultant, details, photoUrl}: Props4) => {

    // Determine which source to use: the dynamic photoUrl or the placeholder.
    // sanitizeImageUrl applies width=150 to CDN URLs (avatar size) and passes
    // the local SVG placeholder through unchanged.
    const imageSource = photoUrl
        ? sanitizeImageUrl(photoUrl, { width: 150 })
        : "/src/assets/profile-placeholder-icon.svg";
    const imageAltText = photoUrl ? `Photo of ${consultant}` : "Profile placeholder icon";

    return (
    <>
        <div className="card d-flex flex-column rounded-2 border-0 shadow-sm w-100 h-100 p-4 m-0">
            <div className="card-body d-flex flex-column h-100 py-0">

                    {/* Body Content */}
                    <div>
                        <img
                            src="https://cdn.trailfinders.com/quote-icon.png"
                            className="pb-4"
                            alt="icon"
                        />
                    </div>
                    <div className="flex-grow-1">
                        <span>{details}</span>
                    </div>

                    {/* Staff details */}
                    <div className="mt-auto pt-4">
                        <div className="row row-cols-2 pt-4 lh-1 ">
                            <div className="w-20 pe-0">
                                <div className="avatar">
                                    <img
                                        src={imageSource}
                                        className="card-fluid"
                                        alt={imageAltText}
                                    />
                                </div>
                                
                            </div>
                            <h6 className="item-heading text-strong text-nowrap mb-0 pt-2 pt-md-4">by {consultant}</h6>
                            
                        </div>
                    </div>
                    
            </div>
        </div>
    </>
    )
}

export default CardLayout4